import styles from "./MHeader.module.scss"

import logoPng from "../../assets/images/logo.png"
import { useNavigate } from "react-router-dom"
import { PropsWithChildren, ReactNode, useEffect, useState } from "react"
import arrowPng from "../../assets/images/service_arrow.png"
import menuOpenPng from "../../assets/images/List.png"
import menuClosePng from "../../assets/images/X.png"
import arrow from "../../assets/images/service_arrow.png"
import services from "../../../../pages/service/services"


export default (props = {activateIdx: 0}) => {

    const {
        activateIdx
    } = props
    
    const [menuOpened, setMenuOpened] = useState(false)
    const navigate = useNavigate()
    const goToHome = () => {
        navigate("/")
    }

    return (
        <div className={styles['header-wrapper']}>
            <div className={styles['header']}>
                <img className={styles['header__logo']} src={logoPng} onClick={goToHome}></img>
                <div className={styles['header__menus']}>
                    <div className={styles['header__menus__contactus']}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['header__menus__contactus__a']}>Contact</a></div>
                    <Popup render={<ServicePanel/>} open={setMenuOpened}>
                        <img src={!menuOpened?menuOpenPng:menuClosePng} className={styles['header__menus__icon']}/>
                    </Popup>
                </div>
            </div>
        </div>
    )
}

const Popup = (props: PropsWithChildren<{render: ReactNode, open: (opened: boolean) => void}>) => {

    const [activate, setActivate] = useState(false)

    useEffect(() => {
        props.open(activate)
    }, [activate])

    return (
        <div className={styles["popup"]}>
            <div className="" onClick={() => setActivate(!activate)}>{props.children}</div>
            {
                activate && <div className={styles["popup__box"]}>
                    {props.render}
                </div>
            }
        </div>
    )
}

const ServicePanel = () => {

    const [activate, setActivate] = useState<boolean>(false)
    const navigate = useNavigate()
    const gotoService = (idx: number) => [
        navigate(`/service/${idx}`)
    ]

    return (
        <div className={styles["service-box"]}>
            <div className={styles["service-ul"]}>
                <div className={styles["service-li"]} onClick={() => navigate("/")}>Home</div>
                <div className={styles["service-li"]} onClick={() => setActivate(!activate)}>Service <img src={arrow} className={[styles["service-li__arrow"], activate?styles["service-li__arrow_activated"]:''].join(" ")}/></div>
                <div className={[styles["services"], activate?styles["services_activated"]:''].join(" ")}>
                    <div className={styles["services__group"]}>
                        <div className={styles["services__group__title"]}>Immigration</div>
                        <div className={styles["services__group__items"]}>
                            {
                                services.slice(0, 5).map((it, idx) => <div className={styles["services__group__item"]} onClick={() => gotoService(idx)}>{it.title}</div>)
                            }
                            
                        </div>
                    </div>
                    <div className={styles["services__group"]}>
                    <div className={styles["services__group__title"]}>Other</div>
                        <div className={styles["services__group__items"]}>
                            {
                                services.slice(5).map((it, idx) => <div className={styles["services__group__item"]} onClick={() => gotoService(idx + 5)}>{it.title}</div>)
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

